import * as actionTypes from '../actions/actionTypes';

const initialState = {
    departments: [],
    loadingDepartmentsTree: false,
};

const loadDepartmentsTree = (state) => {
    return {
        ...state,
        loadingDepartmentsTree: true
    }
}

const setDepartmentsTree = ( state, action ) => {
    let newDepartmentsTree = [...action.departmentsData]
    return {
        ...state,
        departments: newDepartmentsTree,
        loadingDepartmentsTree: false
    }
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_DEPARTMENTS_TREE: return loadDepartmentsTree( state );
        case actionTypes.SET_DEPARTMENTS_TREE: return setDepartmentsTree( state, action );
        default: return state;
    }
};
export default reducer;